var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0977C32 7.26166 24.836 0.0976562 16 0.0976562C7.164 0.0976562 0 7.26166 0 16.0977C0 24.0843 5.85067 30.703 13.5 31.903V20.723H9.43733V16.0963H13.5V12.5737C13.5 8.56432 15.8893 6.34832 19.544 6.34832C21.2933 6.34832 23.1253 6.66166 23.1253 6.66166V10.599H21.1067C19.1187 10.599 18.4987 11.8323 18.4987 13.0977V16.0977H22.936L22.2267 20.7243H18.4987V31.9043C26.1493 30.703 32 24.083 32 16.0977Z",
    fill: "url(#paint0_linear_44_182)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_182",
    x1: 16,
    y1: 0.0976562,
    x2: 16,
    y2: 31.9043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2784CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cbd57d6d9404188731b3adacda04ac4c.svg";
export { ForwardRef as ReactComponent };